import { useMutation, useQueryClient } from '@tanstack/react-query'

import { postRequest } from 'src/lib/api-client'
import { sendEvent } from 'src/shared/api/events/send-event'
import { useEventStore } from 'src/shared/store/event-store'

import { consumers } from '../queries'

interface CallLeadRequest {
  receiverId: number
}

export const useCallLead = () => {
  const queryClient = useQueryClient()
  const eventStore = useEventStore()
  const { gclid, sessionId, flowId, utmParams, fbclid } = eventStore

  return useMutation({
    mutationFn: async (data: CallLeadRequest) => {
      const response = await postRequest<CallLeadRequest>('/leads/call?receiver_id=' + data.receiverId)

      if (!response) {
        throw new Error('Failed to create call lead')
      }
      return response
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: consumers.leads._def })

      // Track the successful call lead creation event
      sendEvent({
        eventType: 'call_lead_created',
        info: {
          sessionId,
          flowId,
          receiverId: variables.receiverId,
          ...(fbclid ? { fbclid } : {}),
          ...(gclid ? { gclid } : {}),
          ...(utmParams?.source ? { utm_source: utmParams.source } : {}),
          ...(utmParams?.medium ? { utm_medium: utmParams.medium } : {}),
          ...(utmParams?.campaign ? { utm_campaign: utmParams.campaign } : {}),
          ...(utmParams?.term ? { utm_term: utmParams.term } : {}),
          ...(utmParams?.content ? { utm_content: utmParams.content } : {}),
          ...(utmParams?.ad ? { utm_ad: utmParams.ad } : {}),
        },
      })
    },
    onError: (error, variables) => {
      // Track the error event
      sendEvent({
        eventType: 'call_lead_creation_error',
        info: {
          error: error instanceof Error ? error.message : 'Unknown error',
          receiverId: variables.receiverId,
          ...(fbclid ? { fbclid } : {}),
          ...(gclid ? { gclid } : {}),
          ...(utmParams?.source ? { utm_source: utmParams.source } : {}),
          ...(utmParams?.medium ? { utm_medium: utmParams.medium } : {}),
          ...(utmParams?.campaign ? { utm_campaign: utmParams.campaign } : {}),
          ...(utmParams?.term ? { utm_term: utmParams.term } : {}),
          ...(utmParams?.content ? { utm_content: utmParams.content } : {}),
          ...(utmParams?.ad ? { utm_ad: utmParams.ad } : {}),
        },
      })
    },
  })
}
